import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

export function getWorkbenchInstances() {
  return request(`${ROOT_SERVER_URL}/api/workbench-instances`);
}
